export default __webpack_public_path__ + "static/media/liability-mobile-1.72aea50d.jpg";